import * as lottieAnimation from "./lottie_spinner.json";
import Lottie from "react-lottie";

export default function Spinner(props) {
  const { height = 200, width = 200 } = props;

  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: lottieAnimation.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Lottie
      options={lottieOptions}
      height={height}
      width={width}
      style={{ cursor: "auto" }}
      isClickToPauseDisabled={true}
    />
  );
}
